import React from 'react';
import {
  FDIcon,
  FDList,
  FDListItem,
  FDListItemText, FDListItemTextRightAligned,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const TaxStrategyTabList = ({ resource, currentTaxStrategyTab, onTabChange }) => {
  const { loadModalCollectionByLink } = useModalContext();
  const reviewTab = resource.attr('reviewTab').resources().head();
  const settingsTab = resource.attr('settingsTab').resources().head();
  const summaryTab = resource.attr('summaryTab').resources().head();
  const withdrawalStrategyTab = resource.attr('withdrawalStrategyTab').resources().head();

  return (
    <FDList>
      {settingsTab && (
        <FDListItem
          {...dataAttrs('tax-strategy-tab-settings')}
          onClick={() => onTabChange(settingsTab, false)}
          selected={settingsTab.type() === currentTaxStrategyTab.type()}
        >
          <FDListItemText primaryText={settingsTab.attr('tabName')} />
        </FDListItem>
      )}
      {reviewTab && (
        <FDListItem
          {...dataAttrs('tax-strategy-tab-review')}
          onClick={() => onTabChange(reviewTab, false)}
          selected={reviewTab.type() === currentTaxStrategyTab.type()}
        >
          <FDListItemText primaryText={reviewTab.attr('tabName')} />
        </FDListItem>
      )}
      {summaryTab && (
        <FDListItem
          {...dataAttrs('tax-strategy-tab-summary')}
          onClick={() => onTabChange(summaryTab, false)}
          selected={summaryTab.type() === currentTaxStrategyTab.type()}
        >
          <FDListItemText primaryText={summaryTab.attr('tabName')} />
        </FDListItem>
      )}
      {withdrawalStrategyTab && (
        <FDListItem
          {...dataAttrs('tax-strategy-tab-withdrawal-strategy')}
          onClick={() => {
            loadModalCollectionByLink(withdrawalStrategyTab.relationship(fr.relationships.navigate.name).link('related').url());
          }}
          selected={false}
        >
          <FDListItemText primaryText={withdrawalStrategyTab.attr('tabName')} />
          <FDListItemTextRightAligned primaryText={<FDIcon size="sm" icon="openExternally" />} />
        </FDListItem>
      )}
    </FDList>
  );
};

TaxStrategyTabList.defaultProps = {
};

TaxStrategyTabList.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  currentTaxStrategyTab: PropTypes.instanceOf(fr.Resource).isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default TaxStrategyTabList;
